import { c as _c } from "react/compiler-runtime";
import { ListItemMenu } from "@components/common/mobile/list-item-menu";
import { useTeamMenuOptions } from "@pages/members/teams/use-team-menu-options";
/**
 * Renders a 3-dot menu with actions for a single team row in the table.
 */
export function TeamOptionsMenu(t0) {
  const $ = _c(7);
  const {
    team,
    shouldExcludeRemove,
    memberToRemove,
    shouldConfirmTeamRoleChange
  } = t0;
  let t1;
  if ($[0] !== memberToRemove || $[1] !== shouldConfirmTeamRoleChange || $[2] !== shouldExcludeRemove) {
    t1 = {
      shouldExcludeRemove,
      memberToRemove,
      shouldConfirmTeamRoleChange
    };
    $[0] = memberToRemove;
    $[1] = shouldConfirmTeamRoleChange;
    $[2] = shouldExcludeRemove;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const menuItems = useTeamMenuOptions(t1);
  let t2;
  if ($[4] !== menuItems || $[5] !== team) {
    t2 = <ListItemMenu item={team} menuItems={menuItems} />;
    $[4] = menuItems;
    $[5] = team;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}